import { makeStyles } from 'tss-react/mui';

import { drawerClasses } from '@mui/material';

export default makeStyles()({
    drawer: {
        [`& .${drawerClasses.paper}`]: {
            width: '85vw',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    }
});
